import {TrustedShopsSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/order_success_page/v1/sections.types';
import {Head} from '@aboutyou/head-elements';
import {COLORS, mobileOnlyLinaria} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {useEffect, useState} from 'react';

const BADGE_CONTAINER_ID = 'trustbadgeCustomCheckoutContainer';

let isTrustedShopScriptLoaded = false;

export const TrustedShop = (props: TrustedShopsSection) => {
  const {orderId, amount, buyerEmail, currency, paymentType, badgeId} = props;
  const [mountScript, setMountScript] = useState(false);

  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    let reInitTimeout: ReturnType<typeof setTimeout> | undefined;

    if (
      isTrustedShopScriptLoaded ||
      document.querySelector(`script[src*="${badgeId}.js"]`)
    ) {
      isTrustedShopScriptLoaded = true;

      const {trustbadge} = window;
      if (trustbadge && typeof trustbadge.reInitialize === 'function') {
        reInitTimeout = setTimeout(() => {
          trustbadge.reInitialize();
        }, 50);
      }
    } else {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setMountScript(true);
      isTrustedShopScriptLoaded = true;
    }

    return () => {
      clearTimeout(reInitTimeout);

      if (
        typeof window.trustbadge !== 'undefined' &&
        typeof window.trustbadge.remove === 'function'
      ) {
        window.trustbadge.remove();
      }
    };
  }, [badgeId]);

  return (
    <>
      <BadgeContainer id={BADGE_CONTAINER_ID} />

      <div
        id="trustedShopsCheckout"
        style={{display: 'none'}}
        aria-hidden="true"
      >
        <span id="tsCheckoutOrderNr">{orderId}</span>
        <span id="tsCheckoutBuyerEmail">{buyerEmail}</span>
        <span id="tsCheckoutOrderAmount">{amount}</span>
        <span id="tsCheckoutOrderCurrency">{currency}</span>
        <span id="tsCheckoutOrderPaymentType">{paymentType}</span>
      </div>

      <Head>
        {mountScript && (
          <script
            async
            data-mobile-position="right"
            src={`https://widgets.trustedshops.com/js/${badgeId}.js`}
          />
        )}
      </Head>
    </>
  );
};

const BadgeContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  margin: 2rem 0;

  ${mobileOnlyLinaria(`
    padding: 1.5rem 0;
    background-color: ${COLORS.White};
        margin: 0.5rem 0;

    `)}
`;
